import { useKnopClient } from "@opstel/contexts/knopClient/useKnopClient";
import { useQuery } from "@tanstack/react-query";

export function useLocationListQuery() {
  const { knopClient } = useKnopClient();

  return useQuery({
    queryKey: ["location-list"],
    queryFn: async () => {
      const locations = await knopClient.getLocationList();
      return locations.toSorted((a, b) => a.name.localeCompare(b.name));
    },
  });
}
